module.exports = "//static.hsappstatic.net/FormsUI/static-2.58097/img/types/new_editor_form.png"